import * as React from "react"
import { useTranslation } from "react-i18next"

import { Link } from "./Styles"

const ConflictMessage = ({ forceSave }: { forceSave: () => void }): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      {t("catalog.server_reload.conflict.message_before_link")}
      <Link onClick={forceSave}>{t("catalog.server_reload.conflict.force_save")}</Link>.
    </>
  )
}

export default ConflictMessage
